import { Tag } from '@nimbus-ds/components';
import { PriceTableDto } from '@tiendanube/common';
import { useTranslationCustomers } from 'domains/Customers/hooks';

interface PriceTablesTypeLabelProps {
  priceTable: PriceTableDto;
}

export default function PriceTablesTypeLabel({
  priceTable,
}: Readonly<PriceTablesTypeLabelProps>) {
  const t = useTranslationCustomers();
  const tPathLabel = 'customerForm.priceTablesInformation.modal.typeLabel';

  return <Tag>{t(`${tPathLabel}.${priceTable.type}`)}</Tag>;
}
